import { render } from "./defaultBloc.vue?vue&type=template&id=1fa72703&scoped=true"
import script from "./defaultBloc.vue?vue&type=script&lang=js"
export * from "./defaultBloc.vue?vue&type=script&lang=js"

import "./defaultBloc.vue?vue&type=style&index=0&id=1fa72703&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa72703"]])

export default __exports__